import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure74 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        height: '600px',
        backgroundColor: 'rgba(255, 255, 255, 0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
      exporting: {
        enabled: false
      },
      legend: {
        enabled: false,
      },
      xAxis: [{
        categories: [ 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022 ],
        tickInterval: 1,
        crosshair: {
            width: 1,
            color: '#d7d7d7'
        },
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
            y: 32,
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            }
        },
    }],

    yAxis: [
        {
        labels: {
            format: '{value}',
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            },
        },
        gridLineWidth: 2,
        max: 20000,
        min: 0,
        tickInterval: 5000,
        title: {
            text: "Milliers",
            style: {
                fontSize:'18px',
                color: Highcharts.getOptions().colors[1]
            }
        }
    }],
    tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
            padding: 0
        }
    },
    plotOptions: {
        series: {
            states: {
                hover: {
                    lineWidth: 2
                }
            },
            marker: {
                symbol: 'circle',
                states: {
                    hover: {
                        enabled: true,
                        radius: 5
                    }
                }
            }
        }
    },
    series: [ 
        
    {
        marker: {
            enabled: false
        },
        name: 'Australie et Nouvelle-Zélande',
        type: 'line',
        color: '#5b9bd6',
        zoneAxis: 'x',
        data: [
            296, 342, 392, 468, 543, 622, 698, 740, 759, 760, 760
        ],
    },
    {
        marker: {
            enabled: false
        },
        name: 'Asie centrale et du Sud',
        type: 'line',
        color: '#ed7e31',
        zoneAxis: 'x',
        data: [
	       7258, 8778, 10213, 12011, 13684, 15035, 16176, 17448, 18026, 18079, 18081
        ],
    },

    {
        marker: {
            enabled: false
        },
        name: 'Asie de l’Est et du Sud-Est',
        type: 'line',
        color: '#a6a5a4',
        zoneAxis: 'x',
        data: [
	       2839, 3406, 4098, 4757, 5286, 5832, 6284, 6626, 6859, 7059, 7061
         ],
    },
    {
        marker: {
            enabled: false
        },
        name: 'Amérique latine et Caraïbes',
        type: 'line',
        color: '#ffbf00',
        zoneAxis: 'x',
        data: [
	       4528, 5391, 6230, 6891, 7645, 8195, 8808, 9388, 9742, 9841, 9842
        ],
    },
    {
        marker: {
            enabled: false
        },
        name: 'Afrique du Nord',
        type: 'line',
        color: '#4372c4',
        zoneAxis: 'x',
        data: [
	       2564, 2967, 3348, 3665, 3841, 3978, 4089, 4209, 4300, 4319, 4319,
        ],
    },

    {
        marker: {
            enabled: false
        },
        name: 'Océanie (hors Australie et Nouvelle-Zélande)',
        type: 'line',
        color: '#71ad49',
        zoneAxis: 'x',
        data: [
            32, 61, 70, 75, 79, 79, 79, 81, 81, 82, 82,          
        ],
    },


    {
        marker: {
            enabled: false
        },
        name: 'Afrique subsaharienne',
        type: 'line',
        color: '#265e91',
        zoneAxis: 'x',
        data: [
	       3177, 3814, 4576, 5290, 6207, 7168, 8061, 8783, 9435, 9644, 9674
        ],
    },


    {
        marker: {
            enabled: false
        },
        name: 'Asie de l’Ouest',
        type: 'line',
        color: '#9e480e',
        zoneAxis: 'x',
        data: [
	       2823, 3316, 3829, 4394, 4660, 4915, 5149, 5389, 5559, 5577, 5577
        ],
    },
  ],

}